import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { database } from "../../database/firebase";

const useRoomId = (roomId) => {
  const [roomDetail, setRoomDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getRoomDetail = async () => {
      try {
        setLoading(true);
        await onSnapshot(doc(database, "userRooms", roomId), (doc) => {
          if (doc.exists()) {
            setRoomDetail(doc.data());
            setLoading(false);
          } else alert("Couldn't find the room");
        });
        // const docRef = doc(database, "userRooms", roomId);
        // const docSnapshot = await getDoc(docRef);
        // if (docSnapshot.exists()) {
        //   setRoomDetail(docSnapshot.data());
        //   setLoading(false);
        // } else alert("Couldn't find the room");
      } catch (error) {
        setError(error.message);
      }
    };
    getRoomDetail();
  }, [roomId]);

  return { roomDetail, loading, error };
};

export default useRoomId;
